export default "https://d3fbpisbzpk8wt.cloudfront.net/2026101632554/receiptScanNgMultiple-bundle-7d7cecf8fb3c747bca02ed680acb08cf.png";